import { SxProps } from "@mui/material";

export const sxRefundButton: SxProps = {
  display: 'flex',
  justifyContent: 'start',
  height: '64px',
}

export const sxRefundButtonText: SxProps = {
  textAlign: 'start',
  fontSize: 16,
  fontFamily: 'UnimedSans-bold',
  textTransform: "none",
  marginLeft: '16px',
  color: '#383838',
  marginRight: '20px'
}

export const sxButton: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    padding: '12px 32px ',
    fontWeight: 'bold',
    width: 'auto', 
  '@media (max-width:600px)': {
    width: '100%',
  },
}

export const sxButtonBack: SxProps = {
    fontFamily: 'Unimed-Sans',
    fontWeight: 'bold',
    border: 'none',
    color: '#333',
    textDecoration: 'underline',
    textTransform: 'none'
}
